
export default {
  props: {
    options: {type: Array, required: true},
    skip: {type: Object, required: true},
    disabled: {type: Boolean, default: false}
  },
  emits: ['prompt'],
  data() {
    return {
      selected: new Set(),
    }
  },
  computed: {
    confirm_disabled() {
      if (this.disabled) return true
      if (!this.has_selection) return true
      return false
    },
    has_selection() {
      return this.selected.size > 0
    },
    skipped() {
      return !this.has_selection && this.disabled
    }
  },
  methods: {
    onSelect(ind) {
      this.selected.has(ind) 
        ? this.selected.delete(ind) 
        : this.selected.add(ind)
    },
    onAccept(){    
      const selection = Array.from(this.selected).sort()
      const title = selection.map((ind) => this.options[ind].title).join(', ')
      const objects = selection.map((ind) => this.options[ind].chat_query)
  
      this.$emit('prompt', {
        title: title,
        selected: objects
      })
    },
    onSkip() {
      this.selected = new Set()
      this.$emit('prompt', this.skip.chat_query)
    }
  }
}
